/** Import react/libraries section **/
import React from 'react';

/** Import helpers section **/

/** Import resources section **/
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

/** Import syles section **/
import './ServiceModalStyles.scss';

/** Import component section **/
import ModalComponent from '../../../components/Modal';
import MUITextField from '../../../components/inputs/MUITextField';
import MUISelect from '../../../components/inputs/MUISelect';

const ServiceModalView = ({
  service,
  categories,
  onInputChange,
  onSwitchChange,
  onClose,
  onSave,
  disabled
}) => {
  const title = service?.id ? 'Editar servicio' : 'Agregar servicio';
  return (
    <ModalComponent
      open={true}
      title={title}
      element={service}
      onClose={onClose}
      onConfirm={onSave}
      disabled={disabled}
    >
      <div className="serviceModal">
        <MUITextField
          label="Servicio"
          defaultValue={service?.title}
          type="text"
          id="title"
          name="title"
          onChange={onInputChange}
        />
        <MUISelect
          label="Categoría"
          defaultValue={service?.service_category_id}
          items={categories}
          idSelector="id"
          selector="title"
          noSelectedLabel="Select"
          name="service_category_id"
          onChange={onInputChange}
        />

        <MUITextField
          label="Descripción"
          defaultValue={service?.description}
          type="text"
          id="description"
          name="description"
          onChange={onInputChange}
        />
        <MUITextField
          label="Tiempo máximo (días)"
          defaultValue={service?.max_time}
          type="number"
          id="max_time"
          name="max_time"
          onChange={onInputChange}
        />
        <FormControlLabel
          className="serviceModal_active"
          control={
            <Switch
              label="Activo"
              checked={service?.active === 1}
              onChange={onSwitchChange}
              name="active"
              color="primary"
              inputProps={{
                'aria-label': 'secondary checkbox'
              }}
            />
          }
          label="Activo"
        />
      </div>
    </ModalComponent>
  );
};

export default ServiceModalView;
